/**
 * Whether the composer may take the cursor (a conversation opened, another one chosen, something
 * sent): only with a mouse or trackpad, since on a touch screen it would raise the keyboard, and
 * never from another field someone is typing in or while a dialog is open.
 */
export function mayTakeFocus(state: {
  visible: boolean;
  finePointer: boolean;
  /** The element that has the cursor now is another field (input, textarea, select, editor). */
  elsewhereInField: boolean;
  dialogOpen: boolean;
}): boolean {
  return (
    state.visible &&
    state.finePointer &&
    !state.elsewhereInField &&
    !state.dialogOpen
  );
}
